module.exports = __webpack_public_path__ + "img/qr_code.eb774a6d.png";